import React, { FC } from 'react'

import DefaultLayout, { DefaultLayoutProps } from '../../layouts/DefaultLayout'
import { ActionButtonProps } from '../../components/ActionButton'
import { TitleDescriptionProps } from '../../components/TitleDescription'

import * as SC from './styled'

export type CancelTemplateProps = {
  className?: string
  layout?: DefaultLayoutProps
  titleDescription: TitleDescriptionProps
  actions: {
    accept: ActionButtonProps
    cancel: ActionButtonProps
  }
}

const CancelTemplate: FC<CancelTemplateProps> = (props) => {
  const { layout, titleDescription, actions } = props

  return (
    <DefaultLayout {...layout}>
      <SC.Content>
        <SC.Heading {...titleDescription} />
        <SC.Actions>
          <SC.Cta {...actions.accept} />
          <SC.Cta variant="secondary" {...actions.cancel} />
        </SC.Actions>
      </SC.Content>
    </DefaultLayout>
  )
}

export default CancelTemplate
